import {Component, EventEmitter, Inject, Input, OnInit, Output} from '@angular/core';
import {Favorite} from '@models/favorite';
import {EMPTY_FAVORITE} from '@models/empty';
import {AdService} from '@services/ad.service';
import {CommonService} from '@services/common.service';

@Component({
    selector: 'app-simulator',
    templateUrl: './simulator.component.html',
    styleUrls: ['./simulator.component.scss']
})
export class SimulatorComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;
    @Output() favoriteChange = new EventEmitter();
    backupFavorite: Favorite = Object.assign({}, EMPTY_FAVORITE);

    constructor(public adService: AdService, public commonService: CommonService) {
    }

    ngOnInit(): void {
        this.backupFavorite = Object.assign({}, this.favorite);
        this.backupFavorite.lots =[];
        this.favorite.lots.forEach(function(l, i) {
            this.backupFavorite.lots.push(Object.assign({}, this.favorite.lots[i]));
        } ,this);
    }

    onYesClick(): void {
        this.favorite.price = this.backupFavorite.price;
        this.favorite.notary_price = null;

        this.favorite.amount_rent = this.backupFavorite.amount_rent;
        this.favorite.works_total = this.backupFavorite.works_total;
        if (this.favorite.square !== 0) {
            this.favorite.works_square_price = Math.round(this.favorite.works_total / this.favorite.square);
        } else {
            this.favorite.works_square_price = 0;
        }
        this.backupFavorite.lots.forEach(function(l, i) {
            this.favorite.lots[i].amount_rent = this.backupFavorite.lots[i].amount_rent;
            this.favorite.lots[i].works_total = this.backupFavorite.lots[i].works_total;
            if (this.favorite.lots[i].square !== 0) {
                this.favorite.lots[i].works_square_price = Math.round(this.favorite.lots[i].works_total / this.favorite.lots[i].square);
            } else {
                this.favorite.lots[i].works_square_price = 0;
            }
        }, this)
        this.favorite = this.adService.updateValues(this.favorite);
        this.favoriteChange.emit();
    }

    onNoClick(): void {
      this.backupFavorite = Object.assign({}, this.favorite);
    }

    edit(fields = '') {
        if (fields === 'price') {
            // Set to null to calculate it
            this.backupFavorite.notary_price = null;
        }
        if (fields === 'works_total') {
            this.backupFavorite.works_square_price = null;
            this.backupFavorite.works_help = -1;
        }
        this.backupFavorite = this.adService.updateValues(this.backupFavorite);
    }

    editLot(i, fields = '') {
        if (fields === 'works_total') {
            this.backupFavorite.works_square_price = null;
            this.backupFavorite.works_help = -1;
            this.backupFavorite.lots[i].works_square_price = null;
            this.backupFavorite.lots[i].works_help = -1;
        }
        this.backupFavorite = this.adService.updateValues(this.backupFavorite);
    }

    updateEfficiency() {
        // Frais de notaire inclus
        let priceTotal = Math.round(this.backupFavorite.amount_rent * 12 / (this.backupFavorite.efficiency_brut / 100));

        if (this.backupFavorite.estate_sale === 'Neuf') {
            priceTotal -= this.backupFavorite.works_total;
            this.backupFavorite.price = Math.round(priceTotal / (1 + 0.025));
            this.backupFavorite.notary_price = Math.round(this.backupFavorite.price * 0.025);
        } else {
            priceTotal -= this.backupFavorite.works_total;
            this.backupFavorite.price = Math.round(priceTotal / (1 + 0.08));
            this.backupFavorite.notary_price = Math.round(this.backupFavorite.price * 0.08);
        }

        this.backupFavorite = this.adService.updateValues(this.backupFavorite);
    }

    updateEfficiencyNet() {
        // Frais de notaire inclus
        let priceTotal = Math.round(this.backupFavorite.net_rent * 12 / (this.backupFavorite.efficiency_net / 100));

        if (this.backupFavorite.estate_sale === 'Neuf') {
            priceTotal -= this.backupFavorite.works_total;
            this.backupFavorite.price = Math.round(priceTotal / (1 + 0.025));
            this.backupFavorite.notary_price = Math.round(this.backupFavorite.price * 0.025);
        } else {
            priceTotal -= this.backupFavorite.works_total;
            this.backupFavorite.price = Math.round(priceTotal / (1 + 0.08));
            this.backupFavorite.notary_price = Math.round(this.backupFavorite.price * 0.08);
        }

        this.backupFavorite = this.adService.updateValues(this.backupFavorite);
    }

    updateCashflow() {
        let monthly = this.backupFavorite.amount_rent -  this.backupFavorite.charge - this.backupFavorite.cash_flow
        let montantEmprunte =monthly * (1-Math.pow(1+(this.backupFavorite.rate/12/100) ,-(this.backupFavorite.duration* 12))) / ((this.backupFavorite.rate/12/100)+(this.backupFavorite.rate_insurance/12/100)*(1-Math.pow(1+(this.backupFavorite.rate/12/100),-(this.backupFavorite.duration* 12))))

        let totalProjet = montantEmprunte + this.backupFavorite.apport;
        let prixAchatTotal = totalProjet - this.backupFavorite.other_fees - this.backupFavorite.other_fees_work - this.backupFavorite.works_total - this.backupFavorite.works_not_deduc - this.backupFavorite.furniture_price - this.backupFavorite.banking_fees + - this.backupFavorite.deposit_fees
        if (this.backupFavorite.estate_sale === 'Neuf') {
            this.backupFavorite.price = prixAchatTotal / 1.025;
            this.backupFavorite.notary_price = Math.round(this.backupFavorite.price * 0.025);
        } else {
            this.backupFavorite.price = prixAchatTotal / 1.085;
            this.backupFavorite.notary_price = Math.round(this.backupFavorite.price * 0.08);
        }
        this.backupFavorite = this.adService.updateValues(this.backupFavorite);
    }
}
